import React from 'react'
import LoginForm from 'components/CustomComponents/Form/LoginForm'
import RegistrationForm from 'components/CustomComponents/Form/RegistrationForm'
import PasswordRecoveryForm from 'components/CustomComponents/Form/PasswordRecoveryForm'
import l8n from 'l8n'
import './style.scss'

class AuthForm extends React.Component {
  render() {
    const { mode } = this.props

    let form = null
    if (mode === 'login') form = <LoginForm/>
    if (mode === 'registration') form = <RegistrationForm/>
    if (mode === 'password_recovery') form = <PasswordRecoveryForm/>

    const logoPathName = `/resources/images/logo/${l8n.locale === 'ru' ? '168x54/jivo' : '185x54/jivochat'}_white.svg`
    return (
      <div
        className="auth auth--fullscreen"
        style={{ background: '#373a5b url(/resources/images/background.png) center center repeat' }}
      >
        <div className="auth__block">
          <div className="row">
            <div className="col-xl-12">
              <div className="auth__header">
                <img className={`auth__logo ${l8n.locale === 'ru' ? 'auth__logo_ru': ''}`} src={logoPathName}/>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="auth__header">
                <h1 className="text-white">{l8n.p_affiliate_program}</h1>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="auth__block__inner">
                <div className="auth__block__form">
                  {form}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AuthForm



// WEBPACK FOOTER //
// ./src/components/CustomComponents/Form/AuthForm/index.js